<template>
  <span v-for="textItem in textComponents">
    <a v-if="textItem.isLink" :href="textItem.url">{{ textItem.text }}</a>
    <span v-else>
      {{ textItem.text }}
    </span>
  </span>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";

const props = defineProps<{
  text: string;
}>();

var textComponents = ref(new Array<{
  isLink: boolean,
  text: string,
  url: string
}>());

onMounted(() => {
  splitTextOnLinks(props.text);
});

function splitTextOnLinks(text: string) {
  var regex = new RegExp(/\[(.*?)\]\((.*?)\)/);

  var searchResult = regex.exec(text);

  var remainingText = text;

  while (searchResult != null) {
    var index = searchResult.index;

    var entireMatch = searchResult[0];
    var linkText = searchResult[1];
    var linkUrl = searchResult[2];

    var precedingText = remainingText.slice(0, index);
    remainingText = remainingText.slice(index + entireMatch.length);

    textComponents.value.push({
      isLink: false,
      text: precedingText,
      url: ""
    });
    textComponents.value.push({
      isLink: true,
      text: linkText,
      url: linkUrl
    });

    var searchResult = regex.exec(remainingText);
  }

  if (remainingText.length > 0) {
    textComponents.value.push({
      isLink: false,
      text: remainingText,
      url: ""
    });
  }
}
</script>